import { useCallback, useMemo } from 'react';
import services from 'src/api/service';
import { getDspDetails } from 'src/views/pages/utils';

const defaultAlert = {
  id: 'planExpiry',
  show: false,
  severity: 'warning',
  priority: 0,
  message: 'Your plan will expire soon. Please renew your plan to continue using the platform.',
  title: 'Plan Expiry Alert',
  data: null
};

const getPlanExpiryMessage = (accessLevel, notifications) => {
  const originalMessage = notifications?.[accessLevel?.toLowerCase()] || defaultAlert.message;
  const hasPayNow = typeof originalMessage === 'string' && /\[pay now\]/i.test(originalMessage);
  
  const message = hasPayNow
    ? originalMessage.replace(/\s*\[pay now\]\s*/i, ' ').trim()
    : originalMessage;
  
  return {
    message,
    actionLabel: hasPayNow ? 'Pay Now' : undefined,
    actionPath: hasPayNow ? '/account-settings' : undefined
  };
};

  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
  const dspDetails = getProfile?.dsp ? getDspDetails(getProfile, masterFilter) :{};

const usePlanExpiryAlert = () => {
  const fetchPlanExpiry = useCallback(async (signal = null) => {
    const isExpiryCheckEnabled = process?.env?.REACT_APP_EXPIRY_CHECK_ENABLED === 'YES';
    if (!isExpiryCheckEnabled) return null;

    const loggedInUser = JSON.parse(localStorage.getItem('userAlreadyLogin'));
    if (!loggedInUser || !loggedInUser?.email || dspDetails?.enabledAsOnlyDSP) return null;

    const encodedEmail = encodeURIComponent(loggedInUser?.email);
    const response = await services.getService({
      url: `/sponsor-ads/dashboard/check-expiry?email=${encodedEmail}`,
      payload: {},
      nodeAPI: 1,
      signal
    });
    return response?.data || response;
  }, []);

  const normalizeResponse = useCallback((response) => {
    if (!response?.success) return defaultAlert;

    const { message, actionLabel, actionPath } = getPlanExpiryMessage(
      response?.accessLevel,
      response?.notifications
    );

    const planExpiry = response?.showExpiryMessage
      ? {
          ...defaultAlert,
          show: true,
          message,
          actionLabel,
          onAction: actionPath
            ? () => {
                window.location.href = actionPath;
              }
            : undefined,
          data: response
        }
      : defaultAlert;

    return planExpiry;
  }, []);

  const source = useMemo(() => {
    return {
      id: 'planExpiry',
      fetch: fetchPlanExpiry,
      transform: normalizeResponse
    };
  }, [fetchPlanExpiry, normalizeResponse]);

  return {
    source
  };
};

export default usePlanExpiryAlert;
